import { render, staticRenderFns } from "./epmalladdress.vue?vue&type=template&id=6c594eb0"
import script from "./epmalladdress.vue?vue&type=script&lang=js"
export * from "./epmalladdress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports